import {toTitleCase} from 'App/utils/globals';

export default function makeLabelForOptionObject(option) {
  return option.label || toTitleCase(option.id);
}
